import React, { FC } from "react";
import useSelector from "src/hooks/useSelector";

import "./Overlay.scss";

const Overlay: FC = () => {
    //
    // -- Hooks --
    const isOpen = useSelector((state) => state.navigation.isOpen);

    return (
        <div
            className="overlay"
            style={{
                display: isOpen ? "block" : "none",
            }}
        ></div>
    );
};

export default Overlay;
